<template>
    <span v-if="visible" data-cy="net-amount" class="d-block text-no-nowrap text-caption">
        {{ $t('net_amount') }}:
        {{ $filters.price(amount) }}
    </span>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class NetAmount extends Vue {
        @Prop({required: true}) price

        get amount() {
            return {amount: this.price.amount - this.price.commission.amount, currency: this.price.currency}
        }

        get visible() {
            return this.price?.amount && this.price?.commission?.amount && this.commissionAndNettoCheckbox
        }

        get commissionAndNettoCheckbox() {
            return persistentStore.commissionAndNettoCheckbox
        }
    }

    export default NetAmount
</script>

<style scoped>
    span.caption {
        color: rgba(0, 0, 0, 0.6);
        line-height: 1rem;
    }
</style>
